import { useState } from "react";
import Picker from "react-datepicker";
import { useTranslation } from "react-i18next";

const DatePicker = ({ initDate = new Date(), label, onChange, css = "" }) => {
    const [date, setDate] = useState(initDate);
    const [translate] = useTranslation();

    const handleChange = (date) => {
        setDate(date);
        onChange(date);
    };

    return (
        <div className={`${css}`}>
            {label && <label className="d-block form-label h6">{translate(label)}</label>}
            <Picker
                selected={date}
                onChange={handleChange}
                dateFormat="dd-MMM-yyyy"
                className="form-control"
            />
        </div>
    );
};

export default DatePicker;